import React from 'react';
import apolloSuit from '../../../assets/suits/apollo.png';
import contemporarySuit from '../../../assets/suits/contemporary.png';
import artemisSuit from '../../../assets/suits/artemis.png';
import futureSuit from '../../../assets/suits/future.png';
import Indicator from '../../Common/Indicator/Indicator';
import './EraIntro.scss';

function EraIntro({ eraData, eras }) {
  const suits = [apolloSuit, contemporarySuit, artemisSuit, futureSuit];
  return (
    <section className="eraIntro">
      <div className="eraIntro-contents" id={eraData.id}>
        <Indicator eras={eras} eraData={eraData} origin="intro" />
        <div className="eraIntro__glare" />
        <div className="eraIntro__upper">
          <div className="eraIntro__upper__title">
            <h2>{eraData.era}</h2>
            <h3>{eraData.years}</h3>
            {eraData.copy.map((p, i) => {
              return (
                <p key={i} className="eraIntro__copy eraIntro__copy-desktop">
                  {p}
                </p>
              );
            })}
          </div>

          <img
            className="eraIntro__upper__suit"
            src={suits[eraData.index]}
            alt={`Illustration of ${eraData.era}`}
          />
        </div>
        {eraData.copy.map((p, i) => {
          return (
            <p key={i} className="eraIntro__copy eraIntro__copy-mobile">
              {p}
            </p>
          );
        })}
      </div>
    </section>
  );
}

export default EraIntro;
